<template>
  <div class="externalPaymentForm flex flex-col gap-4">
    <div
      v-if="financingEnabled"
      class="flex flex-col gap-1.5"
      data-cy="external-payment-type-row"
    >
      <span
        class="block text-sm font-medium text-gray-900"
      >
        Payment type
      </span>
      <div
        role="radiogroup"
        aria-label="Payment type"
        class="grid grid-cols-2 gap-2"
        data-cy="payment-type-selector"
      >
        <button
          v-for="opt in paymentTypeOptions"
          :key="opt.value"
          type="button"
          role="radio"
          :aria-checked="paymentType === opt.value"
          :data-cy="`payment-type-${opt.value}`"
          :class="tileClasses(opt.value)"
          @click="paymentType = opt.value"
        >
          {{ opt.label }}
        </button>
      </div>
    </div>

    <ExternalOtherForm
      v-if="paymentType === 'other'"
      ref="paymentForm"
      data-cy="other-form"
    />
    <ExternalFinancingForm
      v-if="paymentType === 'financing'"
      ref="paymentForm"
      data-cy="financing-form"
      :invoice-id="invoiceId"
      :payment-amount-cents="paymentAmountCents"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";

import ExternalFinancingForm from "./external/ExternalFinancingForm.vue";
import ExternalOtherForm from "./external/ExternalOtherForm.vue";

defineProps({
  paymentAmountCents: {
    type: Number,
    default: () => 0
  },
  invoiceId: {
    type: Number,
    default: null
  },
  financingEnabled: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(["update:payment-type"]);

const paymentForm = ref<any>(null);
const paymentType = ref<"other" | "financing">("other");

const paymentTypeOptions: Array<{
  label: string;
  value: "other" | "financing";
}> = [
  { label: "Other processor", value: "other" },
  { label: "Financing", value: "financing" }
];

function tileClasses(value: "other" | "financing") {
  const base =
    "rounded-md border px-3 py-2 text-sm font-medium transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300 cursor-pointer";
  if (paymentType.value === value) {
    return `${base} border-blue-600 bg-blue-50 text-blue-700 ring-1 ring-blue-600`;
  }
  return `${base} border-gray-200 bg-white text-gray-700 hover:border-gray-400`;
}

async function validate() {
  await paymentForm.value.validate();
}

async function getData() {
  await validate();
  return paymentForm.value.getData();
}

defineExpose({ validate, getData });

watch(
  paymentType,
  (val) => {
    emit("update:payment-type", val);
  },
  { immediate: true }
);
</script>
